import { ApiProperty } from "@nestjs/swagger";

export class UnitLineDateRequest {
    @ApiProperty()
    unit: string;
    @ApiProperty()
    date: string;
    @ApiProperty()
    clientId: number;
    @ApiProperty()
    lineId?: string;

    @ApiProperty()
    fromTime: string; // aHH-MM-SS
    @ApiProperty()
    toTime: string; // HH-MaM-SS
    @ApiProperty()
    isGroupByHour: boolean;
}